import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.search";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import listMixin from '../listMixin';
import { mapState } from 'vuex';
import debounce from 'lodash/debounce';
import { userItemsPerListMixin } from '@/utils/vuex';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['title'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'NiotaClassicConsumersList',
  mixins: [listMixin, userItemsPerListMixin],
  props: {
    selectedAccounts: {
      type: Array,
      required: false,
      default: undefined
    }
  },
  data: function data() {
    return {
      lastSearch: '',
      isInitialSearch: false,
      disableFetchOnCreatedMixin: true,
      tableOptions: _objectSpread({}, defaultTableOptions),
      expanded: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('NiotaClassic.Common.table.id'),
          value: 'id',
          align: 'center'
        }, {
          value: 'icon',
          sortable: false,
          align: 'center'
        }, {
          text: this.$i18n_t('NiotaClassic.Consumers.detail.title'),
          value: 'title',
          align: 'start'
        }, {
          text: this.$i18n_t('NiotaClassic.Consumers.table.type'),
          sortable: true,
          value: 'type',
          align: 'start'
        }, {
          text: this.$i18n_t('Common.tenant'),
          sortable: true,
          value: 'accountName'
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.createdAt'),
          value: 'createdAt'
        }].concat(_toConsumableArray(this.isIotHubManager ? [{
          align: 'end',
          sortable: false,
          value: 'actions',
          width: '78'
        }] : [])),
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        }
      };
    }
  }),
  watch: {
    selectedAccounts: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }

      this.updateAccountParams();
      this.fetchList(true);
    }, 500)
  },
  created: function created() {
    defaultTableOptions.itemsPerPage = this.savedUserItemsPerList();
    var page = parseInt(this.$route.query.page, 10) || defaultTableOptions.page;
    var perPage = parseInt(this.$route.query.perPage, 10) || defaultTableOptions.itemsPerPage;
    var search = this.$route.query.search || '';

    if (search) {
      this.isInitialSearch = true;
      this.searchItem = search;
    }

    this.tableOptions.page = page;
    this.tableOptions.itemsPerPage = perPage;
  },
  methods: {
    updatePagination: function updatePagination(e) {
      this.$router.replace({
        query: _objectSpread(_objectSpread(_objectSpread({}, this.$route.query), {
          page: e.page || defaultTableOptions.page
        }), {
          perPage: e.itemsPerPage || defaultTableOptions.itemsPerPage
        })
      }).catch(function (error) {
        console.error(error);
      });
    },
    updateAccountParams: function updateAccountParams() {
      this.$router.replace({
        query: _objectSpread(_objectSpread({}, this.$route.query), {
          accounts: this.getAccountIds(this.selectedAccounts).join(',') || undefined
        })
      }).catch(function (error) {
        console.error(error);
      });
    },
    updateSearchParams: function updateSearchParams(searchTerm) {
      this.$router.replace({
        query: _objectSpread(_objectSpread({}, this.$route.query), {
          search: searchTerm || undefined
        })
      }).catch(function (error) {
        console.error(error);
      });
    },
    fetchList: function fetchList() {
      var _this = this;

      if (this.isFetching) {
        return;
      }

      this.isFetching = true;
      var trimmedSearch = (this.searchItem || '').trim();

      if (this.lastSearch !== trimmedSearch) {
        this.lastSearch = trimmedSearch;

        if (!this.isInitialSearch) {
          this.tableOptions = _objectSpread(_objectSpread({}, this.tableOptions), {}, {
            page: 1
          });
        }

        this.isInitialSearch = false;
      }

      var _this$tableOptions = this.tableOptions,
          sortBy = _this$tableOptions.sortBy,
          sortDesc = _this$tableOptions.sortDesc,
          page = _this$tableOptions.page,
          itemsPerPage = _this$tableOptions.itemsPerPage;
      var sortItem = sortBy && sortBy.length ? sortBy[0] : 'createdAt';
      var doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      var sortDirection = doSortDesc ? 'DESC' : 'ASC';
      var usedPage = Math.max(1, page || 1);
      var usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      var promise = undefined;

      if (trimmedSearch) {
        this.updateSearchParams(trimmedSearch);

        if (!this.selectedAccounts.length) {
          promise = NiotaClassicApiService.consumersFind(trimmedSearch, usedPage, usedItemsPerPage, sortItem, sortDirection);
        } else {
          promise = NiotaClassicApiService.consumersFindByAccount(this.getAccountIds(this.selectedAccounts), trimmedSearch, usedPage, usedItemsPerPage, sortItem, sortDirection);
        }
      } else {
        this.updateSearchParams('');

        if (!this.selectedAccounts.length) {
          promise = NiotaClassicApiService.consumersFetch(usedPage, usedItemsPerPage, sortItem, sortDirection);
        } else {
          promise = NiotaClassicApiService.consumersFetchByAccount(this.getAccountIds(this.selectedAccounts), usedPage, usedItemsPerPage, sortItem, sortDirection);
        }
      }

      promise.then(function (res) {
        if (res.data.consumer) {
          _this.list = res.data.consumer;
        } else {
          _this.list = res.data.consumers;
        }

        _this.serverItemsLength = res.pagination.itemCount;
      }).catch(function (error) {
        console.error('Error fetching consumers', error);
      }).finally(function () {
        _this.isFetching = false;
      });
    },
    deletePromise: function deletePromise() {
      return NiotaClassicApiService.consumersDelete(this.selectedItem);
    },
    handleClickConsumer: function handleClickConsumer(item) {
      this.$router.push("/niota-classic/consumers/".concat(item.id));
    },
    getAccountIds: function getAccountIds(accounts) {
      var ids = [];
      accounts.forEach(function (account) {
        ids.push(account.id);
      });
      return ids;
    }
  }
};